import { render, staticRenderFns } from "./AiCredits.vue?vue&type=template&id=f8576d74&scoped=true"
import script from "./AiCredits.vue?vue&type=script&lang=js"
export * from "./AiCredits.vue?vue&type=script&lang=js"
import style0 from "./AiCredits.vue?vue&type=style&index=0&id=f8576d74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8576d74",
  null
  
)

export default component.exports